import http from "services/http";

export type HttpMethod = "get" | "post";

export interface HotelTransaction {
  _id: string;
  paymentReference: string;
  transactionReference?: string;
  type: string;
  amount: number;
  charges: number;
  active_bank: string;
  status: string;
  discount: boolean;
  accountNumber?: string;
  accountName?: string;
  bankName?: string;
  expiresOn?: string;
  transactionDate: string;
  createdAt: string;
}

export interface HotelBookingGuestGroup {
  adults: number;
  children: unknown[];
}

export interface HotelContactInfo {
  email: string;
  phone: string;
  name: string;
}

export interface HotelBooking {
  _id: string;
  partner_order_id: string;
  transaction_id: HotelTransaction[];
  status: string;
  hotel_id: number;
  hotel_name: string;
  checkin: string;
  checkout: string;
  rooms: number;
  guests: HotelBookingGuestGroup[];
  total_price: number;
  currency: string;
  total_price_usd: number;
  usd_ngn_rate: number;
  contact_info: HotelContactInfo;
  prebook_hash?: string;
  prebook_expires_at?: string;
  createdAt: string;
}

export interface GetHotelBookingsResponse {
  success: boolean;
  message: string;
  data: {
    bookings: HotelBooking[];
    total: number;
    page: number;
    limit: number;
  };
}

export const getHotelBookings = async (
  page = 1,
  limit = 20,
  method: HttpMethod = "get",
): Promise<GetHotelBookingsResponse> => {
  const response = await http.request({
    url: "/hotel/admin/bookings",
    method,
    params: { page, limit },
  });
  return response.data;
};

export const syncHotels = async (
  full = false,
  method: HttpMethod = "get",
): Promise<any> => {
  const response = await http.request({
    url: "/hotel/admin/sync-hotels",
    method,
    params: { full },
  });
  return response.data;
};

export const syncRegions = async (method: HttpMethod = "get"): Promise<any> => {
  const response = await http.request({
    url: "/hotel/admin/sync-regions",
    method,
  });
  return response.data;
};

export const checkBookingStatus = async (
  partnerOrderId: string,
  method: HttpMethod = "get",
): Promise<any> => {
  const response = await http.request({
    url: "/hotel/admin/check-booking-status",
    method,
    params: { partner_order_id: partnerOrderId },
  });
  return response.data;
};
